<template>
  <NavigationHeader title="Veille informationnelle" />
</template>

<script>
export default {
  name: 'ResourcesMonitoringHeader'
}
</script>
